module.exports = __webpack_public_path__ + "img/bed-sheets.06775bd9.png";